// @ts-ignore
export default {
  namespaced: true,
  state: {
    // drag-n-drop
    dragging: false,
    targetDraggingId: null,
    sourceDraggingId: null,
    // end drag stuff
  },
  getters: {
    // drag-n-drop
    dragging: (state: any) => state.dragging,
    targetDraggingId: (state: any) => state.targetDraggingId,
    sourceDraggingId: (state: any) => state.sourceDraggingId,
    addedDragEvent: (state: any) => state.addedDragEvent,
    removedDragEvent: (state: any) => state.removedDragEvent,
    // end drag stuff
  },
  mutations: {

    SET_DRAGGING(state: any, value = false) {
      state.dragging = value
    },
    SET_TARGET_DRAGGING(state: any, categoryId: any) {
      state.targetDraggingId = categoryId
    },
    SET_SOURCE_DRAGGING(state: any, categoryId: any) {
      state.sourceDraggingId = categoryId
    },
    SET_DRAG_EVENTS(state: any, { addedDragEvent, removedDragEvent }: any) {
      state.addedDragEvent = addedDragEvent ?? state.addedDragEvent
      state.removedDragEvent = removedDragEvent ?? state.removedDragEvent
    },
    RESET_DRAG_EVENTS(state: any) {
      state.addedDragEvent = null
      state.removedDragEvent = null
    },
  },
}
